import { useLayoutEffect, useRef } from 'react';

import { Button, type ButtonProps } from '@/components/ui/button.tsx';

type MutationButtonProps = Extract<ButtonProps, { href?: never }>;

/**
 * Workaround to disable ban elevate Button while loading.
 */
export const MutationButton = ({ loading, disabled, ...props }: MutationButtonProps) => {
  const ref = useRef<HTMLButtonElement>(null);

  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.disabled = (disabled ?? false) || (loading ?? false);
    }
  }, [disabled, loading]);

  return <Button {...props} ref={ref} disabled={disabled} loading={loading} />;
};
